/**
 * Extrai o código QR de diferentes formatos de resposta
 * @param input A string contendo o código QR em algum formato
 * @returns O código QR em formato base64 ou null se não for possível extrair
 */
export const extractQr = (input: string | any): string | null => {
  // Se o input for nulo ou indefinido, retorna null
  if (!input) return null;
  
  // Se o input já for um objeto (possivelmente uma resposta JSON já parseada)
  if (typeof input === 'object') {
    console.log('Processando QR de objeto:', input);
    return input.qrCode || input.qr_code || null;
  }
  
  // Se for uma string, tentar processar
  if (typeof input === 'string') {
    // Se for HTML, extrair o base64 da tag img
    const htmlMatch = input.match(/data:image\/png;base64,([^"'>]+)/);
    if (htmlMatch?.[1]) {
      console.log('QR encontrado em formato HTML');
      return htmlMatch[1];
    }
    
    // Se for JSON, verificar se já temos o qrCode diretamente
    try {
      if (input.trim().startsWith('{')) {
        const json = JSON.parse(input);
        console.log('QR processado de JSON:', json);
        
        if (json.qrCode || json.qr_code) {
          return json.qrCode || json.qr_code;
        } else if (json.data?.qrCode || json.data?.qr_code) {
          return json.data.qrCode || json.data.qr_code;
        }
      }
    } catch (e) {
      console.log('Falha ao processar JSON:', e);
    }
    
    // Retornar o input se parece ser base64 diretamente
    if (/^[A-Za-z0-9+/=]+$/.test(input.trim())) {
      console.log('QR parece ser base64 direto');
      return input.trim();
    }
  }
  
  console.log('Não foi possível extrair QR do input');
  return null;
};
